import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["disabled", "uniqueId", "config", "children", "screen"];
import { Component } from 'react';
import UIPricingPageRedirectButton from 'ui-addon-upgrades/button/UIPricingPageRedirectButton';
import { jsx as _jsx } from "react/jsx-runtime";
const APP_NAME = 'workflows';
class PricingPageRedirectWrapper extends Component {
  render() {
    const _this$props = this.props,
      {
        disabled,
        uniqueId,
        config,
        children,
        screen
      } = _this$props,
      propsToPass = _objectWithoutPropertiesLoose(_this$props, _excluded);
    if (!config) {
      return children;
    }
    const {
      upgradeProduct
    } = config;
    return /*#__PURE__*/_jsx(UIPricingPageRedirectButton, Object.assign({}, propsToPass, {
      upgradeData: {
        app: APP_NAME,
        screen: screen,
        uniqueId: uniqueId,
        upgradeProduct: upgradeProduct
      },
      disabled: disabled,
      children: children
    }));
  }
}
PricingPageRedirectWrapper.defaultProps = {
  screen: 'edit',
  uniqueId: 'action-requires-upgrade'
};
export default PricingPageRedirectWrapper;